(function() {
  'use strict';

  // 1. Mobile Menu Drawer Controller (Hardened Initialization Guard Order)
  function initMobileMenuController() {
    const menuToggle = document.getElementById('vq-mobile-menu-toggle') || document.querySelector('[data-vq-mobile-menu-trigger]');
    const drawer = document.getElementById('vq-mobile-nav-drawer');
    const overlay = document.getElementById('vq-mobile-nav-overlay');

    if (!menuToggle || !drawer || !overlay) return;

    if (document.body.dataset.vqMobileMenuInitialized === 'true') return;
    document.body.dataset.vqMobileMenuInitialized = 'true';

    function openMobileMenu() {
      drawer.classList.add('active');
      drawer.classList.add('is-active');
      overlay.classList.add('active');
      overlay.classList.add('is-active');
      drawer.setAttribute('aria-hidden', 'false');
      menuToggle.setAttribute('aria-expanded', 'true');
      menuToggle.setAttribute('aria-label', 'Close menu');
      document.body.classList.add('vq-menu-open');
    }

    function closeMobileMenu() {
      drawer.classList.remove('active');
      drawer.classList.remove('is-active');
      overlay.classList.remove('active');
      overlay.classList.remove('is-active');
      drawer.setAttribute('aria-hidden', 'true');
      menuToggle.setAttribute('aria-expanded', 'false');
      menuToggle.setAttribute('aria-label', 'Open menu');
      document.body.classList.remove('vq-menu-open');
    }

    menuToggle.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const isOpen = drawer.classList.contains('active') || drawer.classList.contains('is-active');
      if (isOpen) {
        closeMobileMenu();
      } else {
        openMobileMenu();
      }
    });

    document.addEventListener('click', function(e) {
      const closeBtn = e.target.closest('[data-vq-mobile-close]') || e.target.closest('#vq-mobile-nav-close');
      if (closeBtn) {
        closeMobileMenu();
        return;
      }

      if (e.target === overlay) {
        closeMobileMenu();
        return;
      }

      const navLink = e.target.closest('#vq-mobile-nav-drawer a');
      if (navLink) {
        closeMobileMenu();
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        closeMobileMenu();
      }
    });
  }

  // 2. Accordion Toggle Handler
  function initAccordions() {
    document.addEventListener('click', function(e) {
      const header = e.target.closest('.vq-accordion-header');
      if (!header) return;

      const item = header.closest('.vq-accordion-item');
      if (!item) return;

      const content = item.querySelector('.vq-accordion-content');
      const isExpanded = header.getAttribute('aria-expanded') === 'true';

      if (isExpanded) {
        header.setAttribute('aria-expanded', 'false');
        item.classList.remove('is-open');
        if (content) content.style.display = 'none';
      } else {
        header.setAttribute('aria-expanded', 'true');
        item.classList.add('is-open');
        if (content) content.style.display = 'block';
      }
    });
  }

  // 3. PDP Gallery Controller
  function initGalleryController() {
    const galleryRoot = document.getElementById('vq-pdp-gallery-root');
    if (!galleryRoot) return;

    if (galleryRoot.dataset.vqGalleryInitialized === 'true') return;
    galleryRoot.dataset.vqGalleryInitialized = 'true';

    const mainImg = galleryRoot.querySelector('#vq-pdp-main-image');
    const stage = galleryRoot.querySelector('#vq-pdp-stage');
    const galleryJsonEl = document.getElementById('vq-gallery-json');

    if (!mainImg || !stage || !galleryJsonEl) return;

    let galleryMedia = [];
    try {
      galleryMedia = JSON.parse(galleryJsonEl.textContent);
    } catch (err) {
      console.error('Error parsing PDP gallery JSON:', err);
      return;
    }

    if (galleryMedia.length <= 1) return;

    let currentIndex = 0;

    function goToImage(index) {
      if (index < 0) index = galleryMedia.length - 1;
      if (index >= galleryMedia.length) index = 0;
      currentIndex = index;

      const media = galleryMedia[currentIndex];
      if (!media) return;

      mainImg.style.opacity = '0.85';
      mainImg.src = media.src;
      if (media.srcset) mainImg.srcset = media.srcset;
      if (media.sizes) mainImg.sizes = media.sizes;
      if (media.alt) mainImg.alt = media.alt;
      setTimeout(() => { mainImg.style.opacity = '1'; }, 100);

      const counterEl = galleryRoot.querySelector('#vq-pdp-current-index');
      if (counterEl) counterEl.textContent = currentIndex + 1;

      const thumbs = galleryRoot.querySelectorAll('.vq-pdp-thumb-btn');
      thumbs.forEach((t, idx) => {
        if (idx === currentIndex) {
          t.classList.add('is-active');
          t.setAttribute('aria-current', 'true');
          t.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        } else {
          t.classList.remove('is-active');
          t.setAttribute('aria-current', 'false');
        }
      });
    }

    galleryRoot.addEventListener('click', function(e) {
      const thumb = e.target.closest('.vq-pdp-thumb-btn');
      if (!thumb) return;

      e.preventDefault();
      const idx = parseInt(thumb.dataset.imageIndex, 10);
      if (!isNaN(idx)) {
        goToImage(idx);
      }
    });

    const prevBtn = galleryRoot.querySelector('#vq-pdp-prev-btn');
    const nextBtn = galleryRoot.querySelector('#vq-pdp-next-btn');

    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        goToImage(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        goToImage(currentIndex + 1);
      });
    }

    const scrollLeft = galleryRoot.querySelector('#vq-thumb-scroll-left');
    const scrollRight = galleryRoot.querySelector('#vq-thumb-scroll-right');
    const container = galleryRoot.querySelector('#vq-pdp-thumbs-container');

    if (scrollLeft && container) {
      scrollLeft.addEventListener('click', function(e) {
        e.preventDefault();
        container.scrollBy({ left: -240, behavior: 'smooth' });
      });
    }

    if (scrollRight && container) {
      scrollRight.addEventListener('click', function(e) {
        e.preventDefault();
        container.scrollBy({ left: 240, behavior: 'smooth' });
      });
    }

    let touchStartX = 0;
    let touchStartY = 0;

    stage.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
    }, { passive: true });

    stage.addEventListener('touchend', function(e) {
      const touchEndX = e.changedTouches[0].screenX;
      const touchEndY = e.changedTouches[0].screenY;
      const diffX = touchEndX - touchStartX;
      const diffY = touchEndY - touchStartY;

      if (Math.abs(diffX) > 40 && Math.abs(diffX) > Math.abs(diffY)) {
        if (diffX < 0) {
          goToImage(currentIndex + 1);
        } else {
          goToImage(currentIndex - 1);
        }
      }
    }, { passive: true });
  }

  // 4. Variant Picker Logic
  function initVariantPicker() {
    const productJsonEl = document.getElementById('vq-product-json');
    if (!productJsonEl) return;

    let productData = {};
    try {
      productData = JSON.parse(productJsonEl.textContent);
    } catch (err) {
      console.error('Error parsing product JSON:', err);
      return;
    }

    if (!productData.variants || productData.variants.length <= 1) return;

    document.addEventListener('click', function(e) {
      const pill = e.target.closest('.vq-pdp-pill');
      if (!pill) return;

      const group = pill.closest('.vq-pdp-option-group');
      if (!group) return;

      group.querySelectorAll('.vq-pdp-pill').forEach(b => b.classList.remove('is-selected'));
      pill.classList.add('is-selected');

      const valLabel = group.querySelector('.vq-pdp-selected-value');
      if (valLabel) valLabel.textContent = pill.dataset.optionValue;

      const selectedOptions = [];
      document.querySelectorAll('.vq-pdp-option-group').forEach(g => {
        const activePill = g.querySelector('.vq-pdp-pill.is-selected');
        if (activePill) selectedOptions.push(activePill.dataset.optionValue);
      });

      const matchedVariant = productData.variants.find(v => {
        return v.options.every((opt, idx) => opt === selectedOptions[idx]);
      });

      if (matchedVariant) {
        const inputId = document.getElementById('vq-pdp-variant-id');
        if (inputId) inputId.value = matchedVariant.id;

        const stickyBtn = document.getElementById('vq-sticky-atc-btn');
        if (stickyBtn) stickyBtn.dataset.variantId = matchedVariant.id;

        const priceEl = document.getElementById('vq-pdp-price');
        if (priceEl && matchedVariant.price) {
          priceEl.textContent = formatMoney(matchedVariant.price);
        }

        const stickyPriceEl = document.getElementById('vq-sticky-atc-price');
        if (stickyPriceEl && matchedVariant.price) {
          stickyPriceEl.textContent = formatMoney(matchedVariant.price);
        }

        const compareEl = document.getElementById('vq-pdp-compare-price');
        if (compareEl) {
          if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
            compareEl.textContent = formatMoney(matchedVariant.compare_at_price);
            compareEl.style.display = 'inline';
          } else {
            compareEl.style.display = 'none';
          }
        }

        const atcBtn = document.getElementById('vq-pdp-atc-btn');
        const atcText = document.getElementById('vq-pdp-atc-text');
        if (atcBtn && atcText) {
          if (matchedVariant.available) {
            atcBtn.removeAttribute('disabled');
            atcText.textContent = 'Add to Cart';
          } else {
            atcBtn.setAttribute('disabled', 'disabled');
            atcText.textContent = 'Sold Out';
          }
        }

        if (stickyBtn) {
          if (matchedVariant.available) {
            stickyBtn.removeAttribute('disabled');
            stickyBtn.textContent = 'Add to Cart';
          } else {
            stickyBtn.setAttribute('disabled', 'disabled');
            stickyBtn.textContent = 'Sold Out';
          }
        }
      }
    });
  }

  // 5. Format Money Helper
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const value = (cents / 100).toFixed(2);
    return '$' + value;
  }

  // 6. Search Triggers
  function initSearchTriggers() {
    document.addEventListener('click', function(e) {
      const trigger = e.target.closest('[data-vq-search-trigger]');
      if (!trigger) return;

      const modal = document.getElementById('vq-search-modal');
      const overlay = document.getElementById('vq-search-overlay');
      if (modal && overlay) {
        modal.classList.add('is-active');
        overlay.classList.add('is-active');
        const input = modal.querySelector('input[type="search"], input[type="text"]');
        if (input) setTimeout(() => input.focus(), 100);
      }
    });

    document.addEventListener('click', function(e) {
      const closeBtn = e.target.closest('[data-vq-search-close]') || e.target.closest('#vq-search-overlay');
      if (!closeBtn) return;

      const modal = document.getElementById('vq-search-modal');
      const overlay = document.getElementById('vq-search-overlay');
      if (modal && overlay) {
        modal.classList.remove('is-active');
        overlay.classList.remove('is-active');
      }
    });
  }

  // 7. Quantity Stepper Handler
  function initQuantity() {
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('[data-qty-change]');
      if (!btn) return;

      const input = document.getElementById('vq-qty-input');
      if (!input) return;

      const change = parseInt(btn.dataset.qtyChange, 10);
      const currentVal = parseInt(input.value, 10) || 1;
      const newVal = Math.max(1, currentVal + change);
      input.value = newVal;
    });
  }

  function initAll() {
    initMobileMenuController();
    initAccordions();
    initGalleryController();
    initVariantPicker();
    initSearchTriggers();
    initQuantity();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();